import Table from '..';
import { getNestedField } from '../../../store/utils';

const SubTable = ({ header, item }) => {
  const { table, value } = header;
  const { headers: subTableHeaders, bodyStyle: subTableBodyStyle } = table!;
  const subTableItems: any[] = value ? getNestedField(item, value) : '';
  return (
    <div
      style={{
        padding: '1.5rem',
      }}
    >
      <Table
        headers={subTableHeaders}
        items={subTableItems}
        // onLineClick={onLineClickHandler}
        size="small"
        bodyStyle={subTableBodyStyle}
      />
    </div>
  );
};

export default SubTable;
